import { z } from "zod";
import { counterpartySchema } from "./counterparty.schema";
import { counterpartyAddressSchema } from "./counterpartyAddress.schema";
import { counterpartyContactSchema } from "./counterpartyContact.schema";

export const counterpartyDetailsSchema = z.object({
    counterparty: counterpartySchema,
    contacts: z.array(counterpartyContactSchema),
    addresses: z.array(counterpartyAddressSchema),
});

export type CounterpartyDetails = z.infer<typeof counterpartyDetailsSchema>;
